import WelcomeBonus from './welcome_bonus';
import TestYourLuck from './test_your_luck';
import Wheel from './wheel';
import Invite from './invite';
import VIP from './vip';
import Facebook from './facebook';
import FacebookFollow from './facebook-follow';
import Methods from './methods';
import Tournament from './tournament_winter';
import BonusZone from './bonus-zone';
import TournamentSummer from './tournament_summer';
import NEW_SLIDES from './new';
import NEW_SLIDES20 from './new20';

export default {
    WelcomeBonus,
    TestYourLuck,
    Wheel,
    Invite,
    VIP,
    FacebookFollow,
    Facebook,
    Methods,
    Tournament,
    TournamentSummer,
    BonusZone,
    NEW_SLIDES,
    NEW_SLIDES20
}